import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import InputWithCleanButton from '../../components/declaracao-importacao/inputWithCleanButton/InputWithCleanButton';
import QCXSelectRegimeTributacaoAutocomplete from '../select-regime-tributacao/QCXSelectRegimeTributacaoAutocomplete';
import QCXFinalAlternativeCurrencyField from '../final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXFinalPercentualField from '../final-percentual-field/QCXFinalPercentualField';

const useStyles = makeStyles(() => ({
  gridFields: {
    paddingBottom: '16px',
  },
}));

export default function QCXCBSFormGroup({ intl, modes, submitSucceeded, parentModel, paraRepasseAuxiliar = false }) {
  const { isConsult, isSubConsult, isSubNone } = modes;

  const { t } = useTranslation();

  const classes = useStyles();

  const { values } = useFormState();

  return (
    <>
      <Grid item className={classes.gridFields} xs={6} sm={6} md={6} lg={6}>
        <InputWithCleanButton>
          <QCXSelectRegimeTributacaoAutocomplete
            name="cbs.regimeTributacao.id"
            label={t('com.muralis.qcx.regimeTributacao')}
            initialValues={values}
            disabled={isConsult || isSubConsult || isSubNone}
          />
        </InputWithCleanButton>
      </Grid>

      {!paraRepasseAuxiliar && (
        <>
          <Grid item className={classes.gridFields} xs={6} sm={6} md={6} lg={6}>
            <QCXFinalAlternativeCurrencyField
              name="cbs.baseCalculoReal"
              label={t('com.muralis.qcx.baseCalculoReais')}
              intl={intl}
              submitSucceeded={submitSucceeded}
              disabled={isConsult || isSubConsult || isSubNone}
              adorned
              scale={7}
            />
          </Grid>
          <Grid item className={classes.gridFields} xs={6} sm={6} md={6} lg={6} />
        </>
      )}

      <Grid item className={classes.gridFields} xs={6} sm={6} md={6} lg={6}>
        <QCXFinalPercentualField
          name="cbs.aliquota"
          label="Alíquota"
          disabled={isConsult || isSubConsult || isSubNone}
          scale={2}
        />
      </Grid>

      {!paraRepasseAuxiliar && (
        <>
          {values?.cbs?.regimeTributacao?.code === '4' ? (
            <>
              <Grid item className={classes.gridFields} xs={6} sm={6} md={6} lg={6} />
              <Grid item className={classes.gridFields} xs={6} sm={6} md={6} lg={6}>
                <QCXFinalPercentualField
                  name="cbs.aliquotaReduzida"
                  label="Percentual redução"
                  disabled={isConsult || isSubConsult || isSubNone}
                  scale={2}
                />
              </Grid>
            </>
          ) : null}

          <Grid item xs={12} sm={6} md={6} lg={6}>
            <QCXFinalAlternativeCurrencyField
              name="cbs.valorDevidoReal"
              label="Valor devido em reais"
              disabled
              adorned
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <QCXFinalAlternativeCurrencyField
              name="cbs.valorRecolherReal"
              label="Valor a recolher em reais"
              disabled
              adorned
            />
          </Grid>
        </>
      )}
    </>
  );
}
